import PropTypes from "prop-types"

export const spaceProps = {
  pt: PropTypes.arrayOf(PropTypes.number),
  pr: PropTypes.arrayOf(PropTypes.number),
  pb: PropTypes.arrayOf(PropTypes.number),
  pl: PropTypes.arrayOf(PropTypes.number),
  mt: PropTypes.arrayOf(PropTypes.number),
  mr: PropTypes.arrayOf(PropTypes.number),
  mb: PropTypes.arrayOf(PropTypes.number),
  ml: PropTypes.arrayOf(PropTypes.number)
}

export const widthProps = {
  width: PropTypes.arrayOf(PropTypes.string)
}

export const fontSizeProps = {
  fontSize: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
}



// WEBPACK FOOTER //
// ./src/utils/styled-system-props.js